<template>
    <div>
         
        <div class="container" style="margin-top:-15px;"> 
             
            <el-table style="margin-top:-10px;" :data="tableData" size="small" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                 
                <el-table-column prop="id" width="80" align="center" label="编号"></el-table-column>
                <el-table-column prop="name" width="80" align="center" label="代理">
                    <template slot-scope="scope">
                        {{scope.row.realName?scope.row.realName:scope.row.loginName}}
                    </template>
                </el-table-column>
                <el-table-column prop="woType" width="80" align="center" label="分类">
                    <template slot-scope="scope">
                        {{scope.row.woType==1?'订单问题':scope.row.woType==2?'佣金问题':scope.row.woType==3?'产品问题':scope.row.woType==4?'系统 bug':scope.row.woType==5?'投诉建议':''}}
                    </template>
                </el-table-column> 
                <el-table-column prop="title" min-width="100" align="left" label="标题">
                    <template slot-scope="scope">
                        <el-tooltip  class="item" effect="dark" :content="scope.row.title" placement="bottom" open-delay="100" hide-after="1500">
                                <span style="font-size:12px;width:100%;overflow:hidden;display: inline-block;
    height: 20px;line-height:29px;">{{scope.row.title}}</span>
                            </el-tooltip>   
                    </template>
                </el-table-column> 
                 <el-table-column prop="linkNo" width="150" align="left" label="关联信息">
                    <template slot-scope="scope">
                        <span style="font-size:12px">{{scope.row.linkNo}}</span>
                    </template> 
                </el-table-column> 
                <el-table-column prop="title" min-width="150" align="left" label="内容">
                    <template slot-scope="scope">
                       <el-tooltip  class="item" effect="dark" :content="scope.row.content" placement="bottom" open-delay="100" hide-after="1500">
                                <span style="font-size:12px;width:100%;overflow:hidden;display: inline-block;
    height: 20px;line-height:29px;">{{scope.row.content}}</span>
                            </el-tooltip>   
                    </template> 
                </el-table-column>
                <el-table-column prop="woStatus" width="60" align="center" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.woStatus==2?'success':scope.row.woStatus==1?'primary':'info'">
                            {{scope.row.woStatus==0?'已提交':scope.row.woStatus==1?'处理中':scope.row.woStatus==2?'已回复':scope.row.woStatus==3?'待回复':scope.row.woStatus==4?'已关闭':''}}
                        </el-tag>
                    </template>
                </el-table-column>  
                <el-table-column prop="createTime" width="170" align="center"  label="创建时间"> </el-table-column>      
                <el-table-column label="操作" width="110" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <el-button-group>  
                            <el-tooltip  class="item" effect="dark" content="处理记录" placement="bottom" open-delay="10" hide-after="1500">
                                <el-button icon="el-icon-lx-edit" size="small" type="error"  @click="handleEdit(scope.$index, scope.row)" ></el-button>
                            </el-tooltip>     
                            <el-tooltip  class="item" effect="dark" content="关闭订单"  placement="bottom" open-delay="10" hide-after="1500">
                                <el-button icon="el-icon-lx-roundclose" size="small"  type="eoror"  @click="handDelete(scope.$index, scope.row)" ></el-button> 
                            </el-tooltip>        
                        </el-button-group> 
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20,50,100,1000]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="创建工单" :modal-append-to-body='false' :visible.sync="addVisible"  center="true"   >
            <el-form ref="form1" :model="form1" label-width="50px">
                <el-form-item label="分类" >
                    <el-radio-group v-model.trim="form1.woType" >
                        <el-radio-button label="1">订单问题</el-radio-button> 
                        <el-radio-button label="2">佣金问题</el-radio-button>
                        <el-radio-button label="3">产品问题</el-radio-button>
                        <el-radio-button label="4">系统 bug </el-radio-button>  
                        <el-radio-button label="5">投诉建议</el-radio-button>
                    </el-radio-group> 
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model.trim="form1.title" placeholder="概述问题，不超过20个字"></el-input>
                </el-form-item> 
                <el-form-item label="关联">
                    <el-input v-model.trim="form1.linkNo" placeholder="输入单号或商品编码"></el-input>
                </el-form-item> 
                <el-form-item label="内容">
                    <el-input type="textarea" placeholder="描述问题，不超过100个字" :rows="5" v-model.trim="form1.content" ></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="处理记录" :modal-append-to-body='false' :visible.sync="editVisible"  center="true" top="50px" >
            <el-form ref="form" :model="form" label-width="80px">
                <el-tag style="display:inline-block;width:100%;border-radius:0;border-left:5px solid #409EFF;" type="info">售后问题</el-tag>
                <p style="font-size:12px;border:1px solid #ddd;padding:5px 10px;line-height:20px;">
                    标题：{{form.title}}<br/>
                    类型：{{form.woType==1?'订单问题':form.woType==2?'佣金问题':form.woType==3?'产品问题':form.woType==4?'系统 bug':form.woType==5?'投诉建议':''}}
                    <br/>
                    关联：{{form.linkNo}}<br/>
                    内容：{{form.content}}<br/> 
                </p> 
                <el-tag style="display:inline-block;width:100%;border-radius:0;border-left:5px solid #409EFF;" type="info">处理记录</el-tag>
                <p style="font-size:12px;border:1px solid #ddd;padding:5px 10px;line-height:20px;">
                    <span v-for="item in replyList">
                        <span v-if="item.replyType==1" style="display:inline-block;width:100%">
                            <span style="font-weight:700;display:inline-block;height:30px;line-height:30px;">
                                <img :src="stationLogo" style="width:30px;height:30px;line-height:30px;border-radius:50%;vertical-align:middle;margin-top:-3px;margin-right:5px;">
                                {{stationName}}
                            </span>
                            <span style="float:right;height:30px;line-height:30px;">
                                {{item.createTime}}
                            </span> 
                        </span>
                        <span v-if="item.replyType==1" style="display:inline-block;width:88%;padding:0 10px 0 40px;margin-top:5px;">  {{item.reply}} </span> 
                        <span v-if="item.replyType==2" style="display:inline-block;width:100%">
                            <span style="font-weight:700;display:inline-block;height:30px;line-height:30px;">
                                <img :src="form.avatar" style="width:30px;height:30px;line-height:30px;border-radius:50%;vertical-align:middle;margin-top:-3px;margin-right:5px;">
                                {{form.realName?form.realName:form.loginName}}
                            </span>
                            <span style="float:right;height:30px;line-height:30px;">
                                {{item.createTime}}
                            </span> 
                        </span>
                        <span v-if="item.replyType==2" style="display:inline-block;width:88%;padding:0 10px 0 40px;margin-top:5px;">   {{item.reply}}  </span>
                    </span>
                </p> 
                 <el-tag v-if="form.woStatus==1 || form.woStatus==2 || form.woStatus==3 " style="display:inline-block;width:100%;border-radius:0;border-left:5px solid #409EFF;" type="info">回复</el-tag>
                 <el-input v-if="form.woStatus==1 || form.woStatus==2 || form.woStatus==3 " type="textarea" placeholder="回复问题，不超过50字" :rows="3" v-model.trim="form.reply" ></el-input>
                
            </el-form>
            <span slot="footer" v-if="form.woStatus==1 || form.woStatus==2 || form.woStatus==3 " class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span> 
            </el-form> 
        </el-dialog>
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,replyForm,getReplayList} from '../../api/woHandle';
import Bus from "../common/woNavBus";
export default {

    data() {
        return { 
            replyList:[],
            stationLogo:'',
            stationName:'',
            avatar:'',
            username:'',
            mid:'',
            secret:'',
            stationId:'',
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false,
            pageTotal: 0,
            form: {  
                replyType:'2',
            },
            form1: {  
                woType:1,
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted() {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId'); 
        this.getData(this.query);  
        Bus.$on("getData", () => {
	      //a传来的参数  
	      this.getData(this.query) // 可以做其他操作
	    });
    },
    methods: { 
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData(this.query);
        },
        //刷新
        refresh(){
            history.go(0); 
        },
        //重置
        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'gname', ''); 
            this.getData(this.query);
            //清空下拉框   
        }, 
        //查询 
        getData(query){
            // 获取列表数据   
            query.stationId = this.stationId;   
            query.woStatus = '2';
            fetchData(query).then(res => {   
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
            });
        },
        // 删除
        handDelete(index, row) {  
            row.stationId = this.stationId;
            row.woStatus = '4'; 
            handDelete(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success('关闭成功');  
                    this.getData(this.query);
                    Bus.$emit("getData");
                }else if(res.code=='201'){ 
                    this.$message.error("关闭异常"); 
                } 
            });
        },
        // 多选操作
       
        // 新增绑定
        addBind() {
            this.addVisible = true;
        },
        //保存新增
        saveForm() {  
            this.form1.mid = this.mid;
            this.form1.stationId = this.stationId;   
            if( !this.form1.title){
                this.$message.error("请填写标题");
                return;
            }
            if( this.form1.title && this.form1.title.length>20){
                this.$message.error("标题不超过20个字");
                return;
            }
            if( !this.form1.content){
                this.$message.error("请填写内容");
                return;
            }
            if( this.form1.content && this.form1.content.length>20){
                this.$message.error("内容不超过100个字");
                return;
            } 
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData(this.query);
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            if(row.woStatus=='2'){
                this.replyName = '回复';
            }else{
                this.replyName = '处理记录';
            } 
            this.stationName = localStorage.getItem('ms_stationName');
            this.stationLogo = localStorage.getItem('ms_stationLogo');
            this.avatar = localStorage.getItem('ms_avatar');
            this.username = localStorage.getItem('ms_username');  
            this.form = row;
            this.form.stationId = this.stationId;
            getReplayList(this.form).then(res => {
                if(res.code=='200'){ 
                    this.replyList = res.data; 
                    this.editVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },
        // 保存编辑
        saveEdit() {   
            if( !this.form.reply){
                this.$message.error("请填写回复");
                return;
            }
            if( this.form.reply && this.form.reply.length>50){
                this.$message.error("回复不超过50个字");
                return;
            }  
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            this.form.replyType = '1';
            this.form.woStatus = '2';
            this.editVisible = false;
            replyForm(this.form).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData(this.query);
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>
<style>

</style>

<style>

@media screen and (max-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 10px;
    }
    .el-dialog,.el-dialog--center{
        width:315px;
    }
     .el-dialog__header {
        padding: 10px 10px 0px;
    }
    .btnCss{
       height:40px;
       margin-left:10px; 
    }
    .handle-del {
        float:left; 
        margin-top:10px;
        margin-left:10px; 
        margin-right:10px;  
    }
} 
@media screen and (min-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
     .el-dialog__header {
        padding: 20px 20px 0px;
    }
    
    .el-dialog,.el-dialog--center{
        width:560px;
    }
    .btnCss{
        
        display:inline-block;
    }
    .handle-del {
        float:right; 
    }
} 

 

.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
